/* eslint-disable camelcase */
import {
  useRef,
  useEffect,
} from 'react';

import { User } from '@gymcloud/core'

import {
  Flex,
  Text,
  SVG,
} from 'web-styled';

import Message from './Message';

type Props = {
  user: User,
  messages: any[],
  onMarkRead: { (): void },
};

const Messages = ({
  user,
  messages,
  onMarkRead,
}: Props) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.scrollTop = ref.current.scrollHeight;
    }
    onMarkRead();
  }, [messages.length]);

  return (messages.length > 0) ? (
    <Flex
      column
      width="100%"
      height="100%"
      scrollY
      padding="15px 15px 5px 15px"
      ref={ref}
    >
      {messages.map((message, i) => (
        <Message
          key={message.id}
          user={user}
          message={message}
          nextMessage={messages[i + 1]}
        />
      ))}
    </Flex>
  ) : (
    <Flex
      fillSpace
      column
      align="center"
      justify="center"
      spacing={10}
    >
      <SVG.Envelope
        width="100"
        height="75"
      />
      <Text
        color="#cacacb"
      >
        No messages to display
      </Text>
    </Flex>
  );
};

export default Messages;
